(function () {
  const initLede = () => {
    document.querySelectorAll('[data-moi-lede]').forEach((lede) => {
      const text = lede.querySelector('[data-moi-lede-text]');
      const toggle = lede.querySelector('[data-moi-lede-toggle]');
      if (!text || !toggle) return;

      const setExpanded = (expanded) => {
        lede.classList.toggle('is-expanded', expanded);
        toggle.setAttribute('aria-expanded', String(expanded));
        toggle.textContent = expanded ? toggle.dataset.labelLess : toggle.dataset.labelMore;
      };

      const measure = () => {
        if (lede.classList.contains('is-expanded')) return;
        toggle.hidden = text.scrollHeight <= text.clientHeight + 1;
      };

      toggle.addEventListener('click', () => {
        setExpanded(!lede.classList.contains('is-expanded'));
        measure();
      });

      if ('ResizeObserver' in window) {
        new ResizeObserver(measure).observe(text);
      } else {
        window.addEventListener('resize', measure);
      }

      measure();
    });
  };

  const initShippingEstimate = () => {
    const formatDate = (daysAhead) => {
      const date = new Date();
      date.setDate(date.getDate() + daysAhead);
      return date.toLocaleDateString('en-US', {month: 'short', day: 'numeric'});
    };

    const readDays = (el) => {
      const min = parseInt(el.dataset.shipMinDays, 10);
      const max = parseInt(el.dataset.shipMaxDays, 10);
      return Number.isNaN(min) || Number.isNaN(max) ? null : {min, max};
    };

    document.querySelectorAll('[data-shipping-estimate]').forEach((holder) => {
      const days = readDays(holder);
      const end = holder.querySelector('[data-ship-end]');
      if (days && end) end.textContent = formatDate(days.max);
    });

    document.querySelectorAll('[data-ship-window-property]').forEach((input) => {
      const days = readDays(input);
      if (!days) return;
      input.value = `${formatDate(days.min)} and ${formatDate(days.max)}`;
      input.disabled = false;
    });

    document.querySelectorAll('[data-ship-days-property]').forEach((input) => {
      const days = readDays(input);
      if (!days) return;
      input.value = `${days.min}-${days.max}`;
      input.disabled = false;
    });
  };

  const initBarTerms = () => {
    const barVariant = document.querySelector('[data-moi-bar-variant]');
    if (!barVariant) return;

    document.addEventListener('theme:variant:change', (event) => {
      const variant = event.detail && event.detail.variant;
      if (!variant || String(variant.id) === barVariant.value) return;

      barVariant.value = variant.id;
      barVariant.dispatchEvent(new Event('change', {bubbles: true}));
    });
  };

  initShippingEstimate();
  initLede();
  initBarTerms();

  const readStorage = (key) => {
    try {
      return window.sessionStorage.getItem(key);
    } catch (error) {
      return null;
    }
  };

  const writeStorage = (key, value) => {
    try {
      window.sessionStorage.setItem(key, value);
    } catch (error) {
      return;
    }
  };

  const productTitle = () => {
    const title = document.querySelector('#template-product .product__title');
    return title ? title.textContent.replace(/\s+/g, ' ').trim() : document.title;
  };

  const currentPrice = () => {
    const price = document.querySelector('#template-product [data-product-price]');
    return price ? price.textContent.replace(/\s+/g, ' ').trim() : '';
  };

  const fillMessage = (scope) => {
    const message = scope.querySelector('[data-moi-message]');
    if (!message) return;

    const text = (message.dataset.template || '')
      .replace(/\[product\]/g, productTitle())
      .replace(/\[price\]/g, currentPrice())
      .replace(/\[url\]/g, window.location.origin + window.location.pathname);
    const encoded = encodeURIComponent(text);

    message.textContent = text;

    scope.querySelectorAll('[data-moi-share]').forEach((link) => {
      const base = link.dataset.moiShareBase || '';

      if (link.dataset.moiShare === 'whatsapp') link.href = `${base}?text=${encoded}`;
      if (link.dataset.moiShare === 'sms') link.href = `${base}?&body=${encoded}`;
      if (link.dataset.moiShare === 'email') {
        link.href = `mailto:?subject=${encodeURIComponent(link.dataset.moiShareSubject || '')}&body=${encoded}`;
      }
    });
  };

  const focusableSelector = 'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])';
  let activeDrawer = null;
  let lastTrigger = null;

  const closeDrawer = () => {
    if (!activeDrawer) return;

    const drawer = activeDrawer;
    activeDrawer = null;
    drawer.classList.remove('is-open');
    document.documentElement.classList.remove('moi-has-drawer');
    document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));
    window.setTimeout(() => {
      if (drawer !== activeDrawer) drawer.hidden = true;
    }, 300);

    if (lastTrigger && document.contains(lastTrigger)) lastTrigger.focus();
  };

  const openDrawer = (drawer, trigger) => {
    if (activeDrawer) closeDrawer();

    activeDrawer = drawer;
    lastTrigger = trigger || null;
    fillMessage(drawer);
    document.querySelectorAll('[data-moi-badge].is-nudged').forEach((badge) => badge.classList.remove('is-nudged'));
    drawer.hidden = false;
    document.documentElement.classList.add('moi-has-drawer');

    const status = drawer.querySelector('[data-moi-copy-status]');
    if (status) status.textContent = '';

    window.requestAnimationFrame(() => {
      drawer.classList.add('is-open');
      drawer.querySelector('[data-moi-drawer-panel]').focus();
    });

    document.dispatchEvent(
      new CustomEvent('theme:scroll:lock', {bubbles: true, detail: drawer.querySelector('[data-moi-drawer-body]')})
    );
  };

  const trapFocus = (event) => {
    const panel = activeDrawer.querySelector('[data-moi-drawer-panel]');
    const focusable = Array.from(panel.querySelectorAll(focusableSelector)).filter((el) => el.offsetParent !== null);
    if (!focusable.length) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (event.shiftKey && (document.activeElement === first || document.activeElement === panel)) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  };

  const copyLink = (button) => {
    const url = button.dataset.moiCopy;
    const status = button.closest('[data-moi-drawer]').querySelector('[data-moi-copy-status]');
    const announce = () => {
      if (status) status.textContent = status.dataset.copied;
    };
    const fallback = () => window.prompt(button.textContent.trim(), url);

    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(url).then(announce).catch(fallback);
    } else {
      fallback();
    }
  };

  const initDrawers = () => {
    document.querySelectorAll('[data-moi-drawer]').forEach((drawer) => document.body.appendChild(drawer));

    document.addEventListener('click', (event) => {
      const opener = event.target.closest('[data-moi-drawer-open]');
      if (opener) {
        const drawer = document.getElementById(opener.dataset.moiDrawerOpen);
        if (!drawer) return;

        event.preventDefault();
        openDrawer(drawer, opener);
        return;
      }

      if (event.target.closest('[data-moi-drawer-close]')) {
        event.preventDefault();
        closeDrawer();
        return;
      }

      const copy = event.target.closest('[data-moi-copy]');
      if (copy) {
        copyLink(copy);
        return;
      }

      const calendly = event.target.closest('[data-moi-calendly]');
      if (calendly && window.Calendly && typeof window.Calendly.initPopupWidget === 'function') {
        event.preventDefault();
        closeDrawer();
        window.Calendly.initPopupWidget({url: calendly.href});
      }
    });

    document.addEventListener('keydown', (event) => {
      if (!activeDrawer) return;

      if (event.key === 'Escape') closeDrawer();
      if (event.key === 'Tab') trapFocus(event);
    });
  };

  const initBadgeNudge = () => {
    const badge = document.querySelector('[data-moi-badge]');
    const nudgeDelay = badge ? parseInt(badge.dataset.nudgeDelay, 10) || 0 : 0;
    const storageKey = 'moi-stylist-nudged';

    if (!badge) return;

    document.body.appendChild(badge);
    if (nudgeDelay <= 0 || !badge.querySelector('.moi-badge__nudge') || readStorage(storageKey)) return;

    window.setTimeout(() => {
      if (activeDrawer) return;

      writeStorage(storageKey, '1');
      badge.classList.add('is-nudged');
      window.setTimeout(() => badge.classList.remove('is-nudged'), 8000);
    }, nudgeDelay * 1000);
  };

  initDrawers();
  initBadgeNudge();
})();
